define('controllers/admin/users',['require','johngrid','hotkeys'],function (require) {
    var CreateJohnGrid = require('johngrid');
    require('hotkeys');
    return function() {
        var table = $("#tblUsers"),
                columns = [{ DataField: "Actions", AllowSorting: false }, { DataField: "UserName" }, { DataField: "LastActivityDate" },
                           { DataField: "Email" }, { DataField: "IsApproved" }, { DataField: "IsLockedOut" },
                           { DataField: "LastLoginDate" }, { DataField: "CreateDate" }, { DataField: "Name", SortField: "FirstName" }, { DataField: "PrimaryKey", HeaderText: "UserId", SortField: "UserId" }],
                dsURL = "UsersAJAX.aspx",
                grid = CreateJohnGrid(),
                headerTemplate = $("#headerTemplate"),
                txtSearchTerm = $("#txtSearchTerm", headerTemplate);

        grid.sorting.allowSorting = true;
        grid.dsPostValues.sortClause = "CreateDate DESC";

        grid.editHelpers.init($("#editUsers"));
        grid.editHelpers.onEdit = function (item) {
            //set approved box
            var chkIsApproved = $("#chkApproved");
            item.approved ? chkIsApproved.prop('checked', true) : chkIsApproved.prop('checked', false);

            //set roles boxes
            var currentRoles = item.userRoles;
            $("input[name='roles']").each(function () {
                var $this = $(this),
                    role = $this.val(),
                    hasRole = $.grep(currentRoles, function (r) { return r == role }).length > 0;

                hasRole ? $this.prop('checked', true) : $this.prop('checked', false);
            });
        };

        grid.onDataBinding = function () {
            grid.dsPostValues.searchTerm = txtSearchTerm.val();
            grid.dsPostValues.approvedFilter = $("select[name='approvedFilter'] option:selected", headerTemplate).val();
            grid.dsPostValues.lockedOutFilter = $("select[name='lockedOutFilter'] option:selected", headerTemplate).val();

        };
        grid.init(table, columns, dsURL);
        $(".johnGridHeader", grid.$table).prepend(headerTemplate);

        //extra grid commands...
        grid.onDataBound = function () {
            $("a[data-method]", grid.$tbody).off('click').on('click', function (e) {
                e.preventDefault();

                var $this = $(this),
                    userId = grid.utilities.getItemForRowClick($this).PrimaryKey,
                    method = $this.attr("data-method"),
                    data = { method: method, PrimaryKey: userId };

                var goodToGo = true;
                if (method != "operate") {
                    var warningMsg = "Are you sure you would like to perform method '{0}', on user {1}";
                    goodToGo = confirm(warningMsg.format(method, userId));
                }

                if (goodToGo) {
                    var loading = $(grid.htmlHelpers.loadingImg(true));
                    $this.hide();
                    $this.after(loading);

                    $.post(dsURL, data, function (response) {
                        Utilities.handleAJAXResponse(response, function (respObj) {
                            grid.utilities.clearMessage();

                            switch (method) {
                                case "resetPassword":
                                    grid.utilities.setInfo("Successfully updated the password for user, {0}. They've been sent an email, letting them know.".format(userId));
                                    break;
                                case "operate":
                                    grid.utilities.setInfo(respObj);
                                    window.location = "/myaccount/";
                                    break;
                                case "unlock":
                                    grid.databind();
                                    grid.utilities.setInfo(respObj);
                                    break;
                                default:
                                    throw "No method on this data-method anchor tag in the John Grid.";
                            }
                            loading.remove();
                            $this.show();
                        }, function (error) {
                            grid.utilities.setError(error);
                            loading.remove();
                            $this.show();
                        });
                    });
                }
            });
        }

        $(".info").fancybox({ autoSize: true });

        Utilities.setDefaultButton(headerTemplate, $(".btnRefresh", grid.$table));
        txtSearchTerm.focus();
        $(document).on('keyup', null, 's', function () {
            txtSearchTerm.focus();
        });
    };
});
